import React, { useEffect, useState, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, CardBody } from "reactstrap";
import DataTable from 'react-data-table-component';
import Tooltip from '@mui/material/Tooltip';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

import moment from 'moment';

import { useNavigate, useLocation } from "react-router-dom";

import CustomerService from "../Customer.service";
import AuthService from "../../../Authentication/auth.service";

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../../components/Loaders/DnaLoader";
import "../../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../../components/Alerts/alerts";

import ContactsAddCustomer from "../Customer Modals/ContactsAddCustomer";
import ContactsUpdateCustomer from "../Customer Modals/ContactsUpdateCustomer";


const CustomerDocs = () => {

  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [modal, setModal] = useState(false);
  const [pdfData, setPdfData] = useState('');

  const location = useLocation();
  const { state } = location;
  console.log("Received Object:-", state);

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
    fetchSingleCustomerDocs();
  }, []);

  function fetchSingleCustomerDocs() {
    var getData = {
      functionName: "GetUserContacts",
      postData: {
        user_id: state._id
      },
    }
    setLoading(true);
    CustomerService.GetUserContacts(getData).then((response) => {
      setLoading(false);
      console.log("Get Customer Contact response:-", response)
      if (response.data.message === "Unauthorized") {
        AuthService.logout();
        navigate("/login");
        window.location.reload();
      }
      else {
        setContacts(response.data.data)

      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        console.log("Net:-", errContent)
        if (errContent) {
          Alerts.swalErrorAlert(errContent)
        }
        else {
          Alerts.swalErrorAlert(t("Server Error, Please try again later."))
        }
      })
  };

  function handleSuccess() {
    fetchSingleCustomerDocs();
  };

  function confirmDeleteDocument(_id) {
    let msg = t("Once deleted, you will not be able to recover this Contact!")
    Alerts.swalConfirmDeleteAlert(msg).then(res => {
      console.log("Resp:-", res)
      if (res === true) {
        sendDelete(_id)
      }
    })
  };

  function sendDelete(id) {
    setLoading(true);
    CustomerService.deleteContact(id).then((response) => {
      setLoading(false);
      console.log("Delete Contact details response:-", response)
      if (response.data.status) {
        fetchSingleCustomerDocs()
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Contact Deleted Successfully."))
        }
        console.log(response.data.message)
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't delete the Contact at the moment."))
        }
      }
    },
      (error) => {
        setLoading(false);
        const errContent =
          (error.response && error.response.data) || error.message || error.toString();
        Alerts.swalErrorAlert(t("Delete operation failed"))
      })
  };
  const toggle = () => {
    setModal(!modal);
  };


  const mycolumns = [
    {
      name: t('Name'),
      selector: row => row.name
    },
    {
      name: t('Email'),
      selector: row => row.email
    },
    {
      name: t('Status'),
      selector: row => row.status
    },
    {
      name: t('Actions'),
      selector: (row) => (
        <div>
          <button className="mt-2 mb-2 btn-icon btn">
            <Tooltip placement="top" title={t("Update")} arrow>
              <i>
                <ContactsUpdateCustomer data={row} onSuccess={handleSuccess} />
              </i>
            </Tooltip>
            <Tooltip placement="top" title={t("Delete")} arrow>
              <i onClick={() => confirmDeleteDocument(row._id)} className="pe-7s-trash text-danger btn-icon-wrapper"> </i>
            </Tooltip>
          </button>
        </div>
      )
    },
  ];



  return (
    <Fragment>
      <Row>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardBody>
              <LoadingOverlay tag="div" active={loading}
                styles={{ overlay: (base) => ({ ...base }) }}
                spinner={<DNALoader />}>
                <Row className="mt-2">
                  <Col md="6">
                    <h4 className="fw-bold mb-1">{t("Customer Contacts")}</h4>
                  </Col>
                  <Col md="6">
                    <ContactsAddCustomer data={state._id} onSuccess={handleSuccess} />
                  </Col>
                  <Col md="12" className="pt-3">

                    <DataTable
                      data={contacts}
                      columns={mycolumns}
                      pagination
                      fixedHeader
                      fixedHeaderScrollHeight="400px"
                    />

                  </Col>
                </Row>
              </LoadingOverlay>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );

};
export default CustomerDocs;